import{__awaiter as r}from"../../../../../node_modules/tslib/tslib.es6.js";import{gql as e}from"graphql-request";import{shopifyStorefrontClientWrapper as o}from"../../../../../lib/clients.js";import{handleError as t}from"../../../../../lib/error-handler.js";import{shopifySfCustomerToUnlikelyCustomer as s}from"../utils/serializers.js";import{CUSTOMER_USER_ERRORS as i}from"../../fragments/errors.js";const u=e`
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        id
        createdAt
      }
      ${i}
    }
  }
`,m=o(((e,o)=>r(void 0,void 0,void 0,(function*(){var r,i;const m=yield e.request(u,o);return{customer:(null===(r=null==m?void 0:m.customerCreate)||void 0===r?void 0:r.customer)?s(m.customerCreate.customer):null,errors:t(null===(i=null==m?void 0:m.customerCreate)||void 0===i?void 0:i.customerUserErrors)}}))));export{u as CUSTOMER_CREATE,m as sfCustomerCreate};
//# sourceMappingURL=customerCreate.js.map
